import { useEffect, useState } from 'react';
import Image from 'next/image';
import { ASSETS } from 'src/common/utils/config';
import {
  Searchbar,
  SearchText,
  BoldText,
  SearchBar,
  Input,
  ClearIcon,
  CountryList,
  CountryName,
  ErrorMessage,
  Item,
} from './styles';
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal';
import { useViewport } from 'src/common/utils/responsive';
import { getRequest } from 'src/common/utils/api/request';
import { getDomainOrigin } from 'src/common/utils/serverConfig';
import { travelV2fUrls } from 'src/common/utils/api/urls';
import { VasViewEvents } from 'src/common/utils/segment/types';
import { sendVasEvents } from 'src/common/utils/segment';
import ItemIconElement from '../common/flag-Icon';

const Index = ({ searchResult, handleClick }) => {
  const [searchTerm, setSearchTerm] = useState(searchResult?.val?.name);
  const [openModal, setOpenModal] = useState(false);
  const [inFocus, setInFocus] = useState(false);
  const [countries, setCountries] = useState<any>([]);
  const [results, setResults] = useState<any>(countries);

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (openModal)
      sendVasEvents(VasViewEvents.VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION);
  }, [openModal]);

  useEffect(() => {
    if (!openModal && !!searchResult?.val)
      setSearchTerm(searchResult?.val?.name);
  }, [openModal, searchResult?.val]);

  useEffect(() => {
    if (!!countries) {
      const searchInput = searchTerm?.trim();

      if (!!searchInput) {
        const lowerCaseSearchTerm = searchInput?.toLowerCase();

        const updatedList = countries?.filter(({ name, code }) => {
          const lowerCaseName = name?.toLowerCase();
          const lowerCaseCode = code?.toLowerCase();

          return (
            lowerCaseName?.startsWith(lowerCaseSearchTerm) ||
            lowerCaseCode?.startsWith(lowerCaseSearchTerm)
          );
        });
        setResults(updatedList);
      } else setResults(countries);
    }
  }, [searchTerm, countries]);

  const getCountries = async () => {
    try {
      const res = await getRequest(
        `${getDomainOrigin()}${travelV2fUrls.getV2fCountries()}`
      );
      if (res) setCountries(res?.data?.data?.countries);
    } catch (error) {
      console.log({ error });
    }
  };

  const renderModal = () => {
    const { isMobile } = useViewport();
    const Modal: any = isMobile ? ModalMobile : ModalDesktop;
    return (
      <Modal
        show={openModal}
        onHide={() => {
          setInFocus(false);
          setOpenModal(false);
        }}
        wrapperStyles={`border-radius: 24px 24px 0px 0px;`}
        showOverlayBackground={true}
        urlhash=""
        header={<BoldText padding={'unset'}>{`Select a country`}</BoldText>}
        padding={'32px 20px'}
        minWidth={isMobile ? '' : '400px'}
      >
        <>
          <SearchBar focus={inFocus}>
            {!inFocus && (
              <Image
                src={ASSETS.SEARCH_ICON}
                width={'18px'}
                height={'18px'}
                style={{ cursor: 'pointer' }}
              />
            )}
            <Input
              focus={inFocus}
              placeholder={'Search country'}
              type={'text'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              onFocus={() => setInFocus(true)}
              onBlur={() => setInFocus(false)}
            />
            {searchTerm && (
              <ClearIcon
                onClick={() => {
                  setSearchTerm('');
                  handleClick({ country: '' });
                  searchResult?.set(null);
                }}
              >
                <Image
                  src={ASSETS.CLOSE_CROSS_MODAL}
                  width={'18px'}
                  height={'18px'}
                  style={{ cursor: 'pointer' }}
                />
              </ClearIcon>
            )}
          </SearchBar>
          <CountryList>
            {results?.length > 0 &&
              results?.map((c: any) => (
                <Item key={c?.name}>
                  <ItemIconElement item={c} />
                  <CountryName
                    key={c?.code}
                    onClick={() => {
                      handleClick({ country: c?.code });
                      setInFocus(false);
                      setOpenModal(false);
                      setSearchTerm(c?.name);
                    }}
                  >
                    {c?.name}
                  </CountryName>
                </Item>
              ))}
            {results?.length === 0 && (
              <ErrorMessage>
                {`No results found ${!!searchTerm ? 'for' : ''}`}
                <b>{!!searchTerm ? ` "${searchTerm}"` : ''}</b>
              </ErrorMessage>
            )}
          </CountryList>
        </>
      </Modal>
    );
  };

  return (
    <>
      <Searchbar
        onClick={() => {
          setOpenModal(!openModal);
        }}
      >
        <Image
          src={ASSETS.SEARCH_ICON}
          width={'16px'}
          height={'16px'}
          style={{ cursor: 'pointer' }}
        />
        <SearchText>{searchTerm || 'Where are you planning to go?'}</SearchText>
      </Searchbar>
      {renderModal()}
    </>
  );
};

export default Index;
